export const esCollaboration = {
  'referral.active': 'Referidos activos',
  'referral.activity': 'Actividad',
  'referral.activeCount': '{count} activos',
  'referral.code': 'Código de referido',
  'referral.codeReady': 'Código listo',
  'referral.codeRegistered': 'Código registrado.',
  'referral.community': 'Comunidad',
  'referral.description':
    'Compártelo. La recompensa llega cuando tu referido activa un plan de pago.',
  'referral.emptyLeaderboard': 'Aún no hay posiciones disponibles.',
  'referral.emptyRewards': 'Tus recompensas aparecerán aquí.',
  'referral.invited': '¿Alguien te invitó?',
  'referral.invitedDescription': 'Registra el código una sola vez. No se puede cambiar después.',
  'referral.invalid': 'El código no es válido, ya fue usado o pertenece a tu propia cuenta.',
  'referral.latest': 'Últimos avances',
  'referral.leaderboard': 'Leaderboard',
  'referral.personalCode': 'Tu código personal',
  'referral.program': 'Programa de referidos',
  'referral.progress': 'Progreso al mes gratis',
  'referral.register': 'Registrar',
  'referral.share': 'Compartir código',
  'referral.shareError': 'Tu navegador no permitió compartir ni copiar el código.',
  'referral.shareText': 'Únete a FinanceGo con mi código {code}',
  'referral.totalTickets': 'Tickets totales',
  'sharing.access': 'Acceso actual',
  'sharing.addTrusted': 'Agrega una persona de confianza',
  'sharing.code': 'Código de 6 dígitos',
  'sharing.codeError': 'El código expiró, no es válido o la cuenta alcanzó su límite.',
  'sharing.confirmRemove': 'Confirmar revocación de {name}',
  'sharing.copy': 'Copiar',
  'sharing.copyError': 'Tu navegador no permitió copiar el código.',
  'sharing.currentPeople': 'Personas en la cuenta',
  'sharing.expiration': 'Expira en {time}',
  'sharing.generate': 'Generar código de 3 minutos',
  'sharing.invitation': 'Invitación privada',
  'sharing.invitationError': 'No pudimos generar la invitación. Revisa el límite de tu plan.',
  'sharing.invited': '¿Te invitaron?',
  'sharing.join': 'Unirme',
  'sharing.joinDescription':
    'El código debe seguir activo. Al unirte, tus finanzas también serán visibles.',
  'sharing.joinTitle': 'Unirme con un código',
  'sharing.keepAccess': 'Conservar acceso',
  'sharing.leave': 'Salir de la cuenta',
  'sharing.leaveConfirm': 'Sí, salir',
  'sharing.memberDescription':
    'Al salir, dejarás de ver las finanzas del owner y tus datos volverán a ser privados.',
  'sharing.memberTitle': 'Estás dentro de una cuenta compartida',
  'sharing.privacy':
    'Cada miembro activo puede ver y editar movimientos, wallets, categorías y agenda de toda la cuenta.',
  'sharing.privacyTitle': 'Compartir significa compartir todas las finanzas.',
  'sharing.remove': 'Quitar a {name}',
  'sharing.revoke': 'Revocar',
  'sharing.upgrade': 'Las cuentas compartidas están disponibles en Plus y Premium.',
} as const;

export const enCollaboration: Record<keyof typeof esCollaboration, string> = {
  'referral.active': 'Active referrals',
  'referral.activity': 'Activity',
  'referral.activeCount': '{count} active',
  'referral.code': 'Referral code',
  'referral.codeReady': 'Code ready',
  'referral.codeRegistered': 'Code registered.',
  'referral.community': 'Community',
  'referral.description': 'Share it. The reward arrives when your referral activates a paid plan.',
  'referral.emptyLeaderboard': 'There are no leaderboard positions yet.',
  'referral.emptyRewards': 'Your rewards will appear here.',
  'referral.invited': 'Did someone invite you?',
  'referral.invitedDescription': 'Register the code once. It cannot be changed afterward.',
  'referral.invalid': 'The code is invalid, was already used, or belongs to your own account.',
  'referral.latest': 'Latest progress',
  'referral.leaderboard': 'Leaderboard',
  'referral.personalCode': 'Your personal code',
  'referral.program': 'Referral program',
  'referral.progress': 'Progress toward a free month',
  'referral.register': 'Register',
  'referral.share': 'Share code',
  'referral.shareError': 'Your browser did not allow sharing or copying the code.',
  'referral.shareText': 'Join FinanceGo with my code {code}',
  'referral.totalTickets': 'Total tickets',
  'sharing.access': 'Current access',
  'sharing.addTrusted': 'Add someone you trust',
  'sharing.code': '6-digit code',
  'sharing.codeError': 'The code expired, is invalid, or the account reached its limit.',
  'sharing.confirmRemove': 'Confirm removal of {name}',
  'sharing.copy': 'Copy',
  'sharing.copyError': 'Your browser did not allow copying the code.',
  'sharing.currentPeople': 'People in the account',
  'sharing.expiration': 'Expires in {time}',
  'sharing.generate': 'Generate a 3-minute code',
  'sharing.invitation': 'Private invitation',
  'sharing.invitationError': 'We could not create the invitation. Check your plan limit.',
  'sharing.invited': 'Were you invited?',
  'sharing.join': 'Join',
  'sharing.joinDescription':
    'The code must still be active. When you join, your finances will also be visible.',
  'sharing.joinTitle': 'Join with a code',
  'sharing.keepAccess': 'Keep access',
  'sharing.leave': 'Leave account',
  'sharing.leaveConfirm': 'Yes, leave',
  'sharing.memberDescription':
    "After leaving, you will no longer see the owner's finances and your data will become private.",
  'sharing.memberTitle': 'You are in a shared account',
  'sharing.privacy':
    'Every active member can view and edit movements, wallets, categories, and the full account schedule.',
  'sharing.privacyTitle': 'Sharing means sharing all finances.',
  'sharing.remove': 'Remove {name}',
  'sharing.revoke': 'Revoke',
  'sharing.upgrade': 'Shared accounts are available on Plus and Premium.',
};
